/*
 * Helpers.
 */

import {OnlineTeammate} from './onlineTeammateModel';

export function buildUniqueOnlineTeammateIdentifier(onlineTeammate: OnlineTeammate) {
  return `${onlineTeammate.teammateId}:${onlineTeammate.connectionId}`;
}
